const roleHomes = [
  { roleId: 111, path: '/supplier/quotation' },
  { roleId: 112, path: '/business-admin/pc-operation/databoard/index' },
  { roleId: 2, path: '/system/user' },
  { roleId: 110, path: '/index' }
]

export const BUSINESS_PATH = '/business-work/inquiries'
export const CUSTOMER_SERVICE_PATH = '/customer-service/shippers'
const DASHBOARD_VIEW_PERMISSION = 'business:dashboard:view'
const DASHBOARD_PATH = '/business-admin/pc-operation/databoard/index'
const EXECUTIVE_COCKPIT_PERMISSION = 'business:executive:cockpit'
const EXECUTIVE_COCKPIT_PATH = '/executive/cockpit'
const retiredHomes = new Set(['/pricing/online-pricing', '/kefu/shlbindex', '/kefu/shindex'])

export function getLoginRedirectPath(path) {
  return !path || retiredHomes.has(path.split(/[?#]/)[0].replace(/\/$/, '')) ? '/workbench' : path
}

export function getWorkbenchPath(user, permissions = []) {
  if (Number(user?.userId) === 1) return '/system/user'
  const roles = Array.isArray(user?.roles) ? user.roles : []
  const roleIds = new Set(roles.map(role => Number(role?.roleId)).filter(Number.isFinite))
  const roleKeys = new Set(roles.map(role => typeof role === 'string' ? role : role?.roleKey))
  const permissionSet = new Set(Array.isArray(permissions) ? permissions : [])
  if (permissionSet.has('*:*:*') || permissionSet.has(EXECUTIVE_COCKPIT_PERMISSION)) return EXECUTIVE_COCKPIT_PATH
  if (permissionSet.has('business:case:list') || roleKeys.has('business')) return BUSINESS_PATH
  if (['kefu', 'customer_service', '客服'].some(key => roleKeys.has(key)) || roleIds.has(114)
      || permissionSet.has('business:shipper:list')) return CUSTOMER_SERVICE_PATH
  const roleHome = roleHomes.find(item => roleIds.has(item.roleId))?.path
  if (roleHome) return roleHome
  if (permissionSet.has(DASHBOARD_VIEW_PERMISSION)) return DASHBOARD_PATH
  return '/index'
}

// 仅在菜单未注册入口时补上真实业务组件；不覆盖已加载的动态路由。
export function ensureWorkbenchRoute(router, path, components = {
  layout: () => import('@/layout/index.vue'),
  business: () => import('@/views/pc-operation/business/index.vue'),
  shipper: () => import('@/views/pc-operation/member/shipper.vue')
}) {
  if (![BUSINESS_PATH, CUSTOMER_SERVICE_PATH].includes(path) || router.getRoutes().some(route => route.path === path)) return
  router.addRoute({
    path: '', component: components.layout, hidden: true,
    children: [{ path, component: path === BUSINESS_PATH ? components.business : components.shipper,
      meta: { title: path === BUSINESS_PATH ? '询单管理' : '客户管理', businessView: path === BUSINESS_PATH } }]
  })
}

export function resolveWorkbenchPath(router, path) {
  return router.getRoutes().some(route => route.path === path) ? path : '/index'
}
